const getters = {
  queue: (state) => {
    return state.queue
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/LoadingQueue/getters.js